module.exports = __webpack_public_path__ + "img/safari-orange.a6fbf182.jpeg";